module.exports = __webpack_public_path__ + "img/24.8bf5ae0e.png";